import { graphql } from "../generated/gql";

export const GetLineTranscriptionsSettings = graphql(`
  query GetLineTranscriptionsSettings($lineId: Int!) {
    getLineTranscriptionsSettings(lineId: $lineId) {
      lineId
      lineLanguage
      calls {
        isEnabled
        reason
      }
      voicemails {
        isEnabled
        reason
      }
    }
  }
`);
